import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ChartWrapper = styled.div`
  width: 100%;
  height: 100%;
  margin-bottom: -${Spacing.S16};
`
